import React, { useEffect, useState } from "react";
import favicon from "../asset/images/favicon.svg";
import logo from "../asset/images/logo.svg";
import whitLogo from "../asset/images/bajaj_finserve_logo_white.svg";
import whiteLogoSmall from "../asset/images/bajaj_finserve_logo_white_s.svg";
import { useNavigate } from "react-router-dom";
import { toggleSidebar } from "../CommonMethhods/CommonMethods";
import icon from "../IconSidebar.json";
import hniIcon from "../asset/images/hni-icon.svg";
function SingleSignOnSideBar() {
  let navigate = useNavigate();
  const project = JSON.parse(localStorage.getItem("project"));
  const partnerProject = JSON.parse(localStorage.getItem("partnerProject"));
  const [module, setModule] = useState();
  const [subModule, setSubModule] = useState();
  const [sessionFlag, setSessionFlag] = useState();

    setTimeout(() => {
      setSessionFlag(sessionStorage.getItem("identifyFlag"));
    }, 0);

  useEffect(() => {
    // Find the user with Name "Telecaller" in the userData array
    const telecallerUser = project?.find((user) => user?.Name === "Telecaller");
    // Check if the Telecaller user exists
    if (telecallerUser) {
      // Set the value in local storage
      localStorage.setItem("userType", telecallerUser?.UserType);
    }
  }, [project]);

  const closeToggleSidebar = () => {
    document.querySelectorAll(".side-blue").forEach((el) => {
      if (el.childNodes[1]) {
        el.childNodes[1].style.display = "none";
      } else if (el.childNodes[0]) {
        el.childNodes[0].style.display = "none";
      }
    });
    let closeSidebar = document.getElementById("sidenav");
    let body2 = document.getElementById("root");
    closeSidebar.classList.remove("toggle-nav");
    body2.classList.remove("show-overlay");

    setModule(false);
    setSubModule(false);
  };
  const NavModule = (subModProjectEndPoint, subModProjectBaseURL) => {
    if (subModProjectEndPoint.startsWith("/")) {
      navigate(`${subModProjectEndPoint}`);
    } else {
      navigate(`/${subModProjectEndPoint}`);
    }
  };
  const handleReportsClick = (index) => {
    toggleSidebar();
    removetooltip();
    if (index === module) {
      setModule(false);
    } else {
      setModule(index);
    }
  };

  const hoverFunction = (e, data) => {
    let sideWidth = document.getElementById("sidenav");
    if (sideWidth.clientWidth < 100) {
      let toolBase = e.target.getBoundingClientRect();
      let topReq = toolBase.y + "px";
      const tooltip = document.createElement("span");
      tooltip.classList.add("sideToolTip");
      tooltip.innerText = data;
      tooltip.style.position = "fixed";
      tooltip.style.top = topReq;
      tooltip.style.left = "90px";
      document.body.appendChild(tooltip);
    } else {
      let toolElement = document.querySelectorAll(".sideToolTip");
      if (toolElement) {
        for (let ele = 0; ele <= toolElement.length - 1; ele++) {
          toolElement[ele].remove();
        }
      }
    }
  };

  const removetooltip = () => {
    let toolElement = document.querySelectorAll(".sideToolTip");
    if (toolElement) {
      for (let ele = 0; ele <= toolElement.length - 1; ele++) {
        toolElement[ele].remove();
      }
    }
  };
  const moduleClick = (
    e,
    index,
    isSubModuleExist,
    projectBaseURL,
    projectEndpoint
  ) => {
    e.stopPropagation();
    if (isSubModuleExist) {
      if (subModule === index) {
        setSubModule(false);
      } else {
        setSubModule(index);
      }
    } else {
      NavModule(projectEndpoint, projectBaseURL);
    }
  };
  console.log(sessionFlag, "sessionFlag");
  return (
    <>
      <div className="main-menu" id="sidenav">
        <div className="close-icon" onClick={() => closeToggleSidebar()}>
          <span className="icon-close"></span>
        </div>

        <div className="main-logo">
          <img src={logo} alt="logo" className="logo1" />
          <img src={favicon} alt="" className="logo2" />
          <img src={whitLogo} alt="" className="whitelogo" />
          <img src={whiteLogoSmall} alt="" className="whitelogos" />
        </div>
        <div className="menu-list">
          <ul>
            {sessionFlag == "true"
              ? partnerProject &&
                partnerProject.map((item, i) => {
                  const { Modules, Name } = item;

                  return (
                    <>
                      <li
                        onClick={() => {
                          handleReportsClick(i);
                        }}
                        key={i}
                        className={"dropdown"}
                        onMouseLeave={removetooltip}
                        onMouseEnter={(e) => hoverFunction(e, Name)}
                      >
                        <a className="side-blue">
                          {Name.toLowerCase() == "telecaller" && (
                            <span className="icon-icon-telecaller_icon"></span>
                          )}
                          {Name.toLowerCase() == "oms" && (
                            <span className="icon-bond"></span>
                          )}
                          {Name.toLowerCase() == "iam" && (
                            <span className="icon-bond"></span>
                          )}
                          {Name.toLowerCase() == "call-recording" && (
                            <span className="icon-RM_mapping"></span>
                          )}
                          {Name.toLowerCase() == "cosmos" && (
                            <span className="icon-cosmos"></span>
                          )}
                          {Name.toLowerCase() == "partner" && (
                            <span className="icon-bond"></span>
                          )}
                          {Name.toLowerCase() == "franchise" && (
                            <span className="icon-bond"></span>
                          )}
                          {Name.toLowerCase() == "hni-telecaller" && (
                            // <span className="icon-icon-telecaller_icon"></span>
                            <img
                              src={hniIcon}
                              alt="hni-icon"
                              height={"20px"}
                              width={"20px"}
                            />
                          )}
                          <i>{Name}</i>
                        </a>
                        {module === i && (
                          <div className="sub-menu">
                            <ul>
                              {Modules.map((moduleData, key) => {
                                const {
                                  Name,
                                  projectBaseURL,
                                  projectEndpoint,
                                  IsSubModuleExist,
                                  SubModule,
                                } = moduleData;
                                return (
                                  <li
                                    key={key}
                                    onClick={(e) =>
                                      moduleClick(
                                        e,
                                        key,
                                        IsSubModuleExist,
                                        projectBaseURL,
                                        projectEndpoint
                                      )
                                    }
                                  >
                                    <a>
                                      {" "}
                                      <span className={icon[Name]}></span>
                                      {Name}
                                    </a>

                                    {IsSubModuleExist === true &&
                                      subModule === key && (
                                        <ul className="subModule">
                                          {SubModule.map((submodule, index) => {
                                            const {
                                              subModuleName,
                                              subprojectEndpoint,
                                              subprojectBaseURL,
                                            } = submodule;
                                            return (
                                              <div>
                                                <a
                                                  className="sub-menu"
                                                  onClick={() => {
                                                    NavModule(
                                                      subprojectEndpoint,
                                                      subprojectBaseURL
                                                    );
                                                    closeToggleSidebar();
                                                  }}
                                                >
                                                  {subModuleName}
                                                </a>
                                              </div>
                                            );
                                          })}
                                        </ul>
                                      )}
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        )}
                      </li>
                    </>
                  );
                })
              : project &&
                project.map((item, i) => {
                  const { Modules, Name } = item;

                  return (
                    <>
                      <li
                        onClick={() => {
                          handleReportsClick(i);
                        }}
                        key={i}
                        className={"dropdown"}
                        onMouseLeave={removetooltip}
                        onMouseEnter={(e) => hoverFunction(e, Name)}
                      >
                        <a className="side-blue">
                          {Name.toLowerCase() == "telecaller" && (
                            <span className="icon-icon-telecaller_icon"></span>
                          )}
                          {Name.toLowerCase() == "oms" && (
                            <span className="icon-bond"></span>
                          )}
                          {Name.toLowerCase() == "iam" && (
                            <span className="icon-bond"></span>
                          )}
                          {Name.toLowerCase() == "call-recording" && (
                            <span className="icon-RM_mapping"></span>
                          )}
                          {Name.toLowerCase() == "cosmos" && (
                            <span className="icon-cosmos"></span>
                          )}
                          {Name.toLowerCase() == "partner" && (
                            <span className="icon-bond"></span>
                          )}
                          {Name.toLowerCase() == "iba" && (
                            <span className="icon-bond"></span>
                          )}
                          {Name.toLowerCase() == "franchise" && (
                            <span className="icon-bond"></span>
                          )}
                          {Name.toLowerCase() == "hni-telecaller" && (
                            // <span className="icon-icon-telecaller_icon"></span>
                            <img
                              src={hniIcon}
                              alt="hni-icon"
                              height={"20px"}
                              width={"20px"}
                            />
                          )}
                          <i>{Name}</i>
                        </a>
                        {module === i && (
                          <div className="sub-menu">
                            <ul>
                              {Modules.map((moduleData, key) => {
                                const {
                                  Name,
                                  projectBaseURL,
                                  projectEndpoint,
                                  IsSubModuleExist,
                                  SubModule,
                                } = moduleData;
                                return (
                                  <li
                                    key={key}
                                    onClick={(e) =>
                                      moduleClick(
                                        e,
                                        key,
                                        IsSubModuleExist,
                                        projectBaseURL,
                                        projectEndpoint
                                      )
                                    }
                                  >
                                    <a>
                                      {" "}
                                      <span className={icon[Name]}></span>
                                      {Name}
                                    </a>

                                    {IsSubModuleExist === true &&
                                      subModule === key && (
                                        <ul className="subModule">
                                          {SubModule.map((submodule, index) => {
                                            const {
                                              subModuleName,
                                              subprojectEndpoint,
                                              subprojectBaseURL,
                                            } = submodule;
                                            return (
                                              <div>
                                                <a
                                                  className="sub-menu"
                                                  onClick={() => {
                                                    NavModule(
                                                      subprojectEndpoint,
                                                      subprojectBaseURL
                                                    );
                                                    closeToggleSidebar();
                                                  }}
                                                >
                                                  {subModuleName}
                                                </a>
                                              </div>
                                            );
                                          })}
                                        </ul>
                                      )}
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        )}
                      </li>
                    </>
                  );
                })}
          </ul>
        </div>
      </div>
    </>
  );
}
export default SingleSignOnSideBar;
